import { FormGroup, FormGroupName, FormArray, FormControlName, FormControl } from '@angular/forms';

export class MultiText {
    placeholder: string;
    formArrayName: string;
    selectFormGroup: FormGroup;
    disabled: boolean;
    // required: boolean;
    subForm: FormGroup;
    frmCtrlName: string;
    constructor(placeholder: string,
                formArrayName: string,
                selectFormGroup: FormGroup,
                disabled: boolean,
                // required: boolean,
                subForm: FormGroup,
                frmCtrlName: string) {
        this.placeholder = placeholder;
        this.formArrayName = formArrayName;
        this.selectFormGroup = selectFormGroup;
        this.disabled = disabled;
        // this.required = required;
        this.subForm = subForm;
        this.frmCtrlName = frmCtrlName;
    }

}

